export default "/_next/static/media/productconference.d690dd72e10e8fd6a7567edb608bf2b7.jpg";